import React from 'react';
import { withFormik } from 'formik';
import { Link, withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { compose, defaultTo, contains } from 'ramda';

import { routes } from '../../routes';
import { apiLogin } from '../../api/user';
import { handleError } from '../../util/forms';

import Card from '../../components/Card';
import Checkbox from '../../components/Forms/Checkbox';
import EditField from '../../components/Forms/EditField';

const Login = ({ errors, touched, values, handleBlur, handleChange, handleSubmit, isSubmitting, isValid, status }) => (
  <div className="col-md-8">
    <Card>
      <Card.Header>Login</Card.Header>
      <Card.Body>
        <form>
          <EditField
            name="email"
            label="E-Mail Address"
            type="email"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
          />
          <EditField
            name="password"
            label="Password"
            type="password"
            required
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password}
          />
          <div className="form-group row">
            <div className="col-md-7 offset-md-3">
              <Checkbox
                name="remember"
                label="Remember me"
                checked={values.remember}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-group row mb-0">
            <div className="col-md-9 offset-md-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isValid || isSubmitting}
                onClick={handleSubmit}
              >
                Login
              </button>
              <Link to={routes.forgotPassword} className="btn btn-link">
                Forgot Your Password?
              </Link>
            </div>
          </div>
        </form>
      </Card.Body>
    </Card>
  </div>
);

export default compose(
  withFormik({
    handleSubmit: (payload, formProps) => {
      const { props } = formProps;
      const queryParams = queryString.parse(props.location.search);
      let referrer;
      try {
        referrer = localStorage.getItem('referrer');
      } catch (err) {
        console.log(err);
      }
      let redirect = defaultTo(queryParams.ref, queryParams.ReturnURL);
      redirect = defaultTo(referrer, redirect);
      redirect = defaultTo(routes.dashboard, redirect);

      apiLogin(payload)
        .then(({ headers }) => {
          if (headers.higher_logic_domain && contains(headers.higher_logic_domain, redirect)) {
            redirect += contains('?', redirect) ? '&' : '?';
            redirect += `higher_logic_member_id=${headers.higher_logic_id}`;
          }
        })
        .then(() => (window.location.href = redirect))
        .catch((err) => handleError(formProps, err));
    },
    mapPropsToValues: () => ({
      email: '',
      password: '',
      remember: false,
    }),
    isInitialValid: true,
    validateOnChange: true,
  }),
  withRouter,
)(Login);
